import { Container } from "@mui/material";

import WorkstationMonitorTab from "~/features/serviceSupport/workstationsMonitor/WorkstationsMonitorTab";
import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

type Props = { viewTitle?: ViewNameTranslation };

export function DemoPage(props: Props) {
  const { viewTitle } = props;

  useNavbar({ viewTitle });

  return (
    <Container sx={{ pt: 5 }}>
      <WorkstationMonitorTab />
    </Container>
  );
}
